import { combineReducers } from "redux";

import storage from "redux-persist/lib/storage";
// slices
import clientslReducer from "./slices/clients";
import usersReducer from "./slices/users";
import trainersReducer from "./slices/trainers";
import generalReducer from "./slices/general";
import departmentsReducer from "./slices/departments";

// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: "root",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

const rootReducer = combineReducers({
  clients: clientslReducer,
  users: usersReducer,
  trainers: trainersReducer,
  general: generalReducer,
  departments: departmentsReducer,
});

export { rootPersistConfig, rootReducer };
